import { UserRole } from 'types/auth';
import useEnums from './useEnum';

const useSkipCompanyQuery = (activeRole?: UserRole | null): boolean => {
  const { UserRolesEnum } = useEnums();
  return (
    !activeRole?.company_id ||
    !!activeRole.property_id ||
    activeRole.user_role_type_id === UserRolesEnum.NOTIFICATION_CONTACT
  );
};

export default useSkipCompanyQuery;
